<template>
  <div class="document-list-item">
    <slot />
  </div>
</template>

<style lang="less" scoped>
.document-list-item {
  min-height: 64px;
  max-height: 64px;
  height: 100%;
  font-weight: 500;
  display: grid;
  align-items: center;
  justify-items: start;
  gap: 16px;
}
</style>
